<template>
  <li ref="dropdown" class="nav-item dropdown">
    <a :class="['nav-link flex-lg-column flex-xl-row dropdown-toggle', { active: props.esActivo }]" role="button" @click="toggleDropdown">
      <i v-if="props.iconCss" :class="['me-lg-1 me-2', props.iconCss]"></i>
      {{ props.texto }}
    </a>
    <ul v-show="isDropdownOpen" :class="['dropdown-menu rounded-0 mt-0 show']" @click="setActiveMenu">
      <slot></slot>
    </ul>
  </li>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const emit = defineEmits(["updateActivo"]);

const props = defineProps({
  texto: String,
  esActivo: Boolean,
  iconCss: String,
});

const isDropdownOpen = ref(false);
const dropdown = ref<HTMLElement | null>(null);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const setActiveMenu = () => {
  isDropdownOpen.value = false;
  emit("updateActivo");
};

const handleClickOutside = (event: MouseEvent) => {
  if (dropdown.value && !dropdown.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
  }
};

onMounted(async () => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(async () => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style lang="scss" scoped>
.nav-item a:not(.active) {
  color: var(--button-ui-nav-nav-item-default);
}

.navbar-nav .nav-link.active {
  border-bottom: var(--border-width-lg) solid var(--border-secondary-default);
  padding-bottom: var(--spacing-2xs);
}

.nav-item i {
  font-size: var(--font-size-body-lg);
  color: var(--icon-secondary-default);
}

.dropdown-menu {
  margin-top: var(--spacing-0);
}

@media (max-width: 991px) {
  .navbar-collapse.collapse .nav-link {
    padding: var(--spacing-md) var(--spacing-0);
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link,
  .navbar-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    gap: var(--spacing-2xs);
    align-items: center;
    min-height: 70px;
  }

  /*FIX MENÚ USUARIO*/
  .menu-usuario .dropdown-menu {
    right: 0;
    left: auto;
  }
}

@media (max-width: 1600px) {
  .nav-item span {
    display: none !important;
  }
}
</style>
